import { render, staticRenderFns } from "./channelUser.vue?vue&type=template&id=3bf32258&scoped=true"
import script from "./channelUser.vue?vue&type=script&lang=js"
export * from "./channelUser.vue?vue&type=script&lang=js"
import style0 from "./channelUser.vue?vue&type=style&index=0&id=3bf32258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf32258",
  null
  
)

export default component.exports